import { Routes } from "~/routes";
import { addBaseUrl } from "./addBaseUrl";
import { JsonLd } from "./JsonLd";

import type { JSX } from "react";

// // // //

interface BreadcrumbItem {
    name: string;
    href: string;
}

/**
 * BreadcrumbSEO
 * Renders BreadcrumbList JSON-LD, always rooted at the home page.
 *
 * NOTE - this used to wrap next-seo's `BreadcrumbJsonLd`, which renders through
 * `next/head` and therefore emits nothing in the App Router. The payload below
 * is byte-equivalent to what next-seo produced.
 */
export function BreadcrumbSEO(props: { items: BreadcrumbItem[] }): JSX.Element {
    const { items } = props;

    return (
        <JsonLd
            data={{
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                itemListElement: [
                    // Always include home page
                    {
                        "@type": "ListItem",
                        position: 1,
                        item: {
                            "@id": addBaseUrl(Routes.home),
                            name: "RWA.xyz",
                        },
                    },
                    // Include additional items
                    ...items.map((each, idx) => ({
                        "@type": "ListItem",
                        position: idx + 2,
                        item: {
                            "@id": addBaseUrl(each.href),
                            name: each.name,
                        },
                    })),
                ],
            }}
        />
    );
}
